/* Versão atual do Sisare Web */
export const APP_VERSION = '1.0.0.14'; // alterar a cada nova publicação/release 02/11/26